import React from 'react';
import { FlatList } from 'react-native';
import { Column } from '../../../containers';
import { AutocompleteResultsRow } from '../../../rows';
import { type ApiResponseRow } from './types';

type AutocompleteResultsProps = {
  readonly items: ApiResponseRow<any>[] | null | undefined;
  readonly handleRowPress: (arg0: ApiResponseRow<any>) => () => void;
  readonly currentText: string;
};

export const AutocompleteResults = ({ items, handleRowPress, currentText }: AutocompleteResultsProps) => {
  return (
    <Column>
      <FlatList
        keyboardShouldPersistTaps="always"
        data={items || []}
        renderItem={({ item }: { readonly item: ApiResponseRow<string> }) => (
          <AutocompleteResultsRow
            {...item}
            onPress={handleRowPress(item)}
            textToHighlight={currentText}
          />
        )}
        keyExtractor={(row) => row.key}
      />
    </Column>
  );
};
